<template>
  <div class="container">
    <div class="text-end p-3">
      <c-primary-button to="/admin/configuraciones/ordenamientos/crear">
        Crear ordenamiento
      </c-primary-button>
    </div>
    <c-card title="Ordenamientos">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Ordenamiento</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ordenamiento in ordenamientos" :key="ordenamiento.id">
            <td>{{ ordenamiento.name }}</td>
            <td class="text-nowrap">
              <router-link
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                :to="`/admin/configuraciones/ordenamientos/${ordenamiento.id}/editar`"
                title="Editar"
                ><i class="fa-solid fa-pen"></i
              ></router-link>
              <a
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                href="javascript:void(0)"
                @click="deleteOrdenamiento(ordenamiento.id)"
                title="Eliminar"
                ><i class="fa-solid fa-trash-can"></i
              ></a>
            </td>
          </tr>
        </tbody>
      </table>
    </c-card>
  </div>
</template>
<script>
import CCard from "@/components/CCard.vue";
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import { all, remove } from "@/services/ordenamientos";
import { showNotification } from "@/services/notification";

export default {
  components: {
    CCard,
    CPrimaryButton,
  },
  data() {
    return {
      ordenamientos: [],
    };
  },
  mounted() {
    this.getOrdenamientos();
  },
  methods: {
    getOrdenamientos() {
      all()
        .then((response) => {
          this.ordenamientos = response.data;
        })
        .catch(() => {
          alert("No pudimos cargar los aspectos");
        });
    },
    deleteOrdenamiento(id) {
      const removeRecord = confirm("¿Estás seguro de eliminar el registro?");
      if (!removeRecord) {
        return;
      }
      remove(id).then(() => {
        showNotification(204, "success", "El registro fue eliminado.");
        this.getOrdenamientos();
      });
    },
  },
};
</script>
